import { Component, OnInit } from '@angular/core';
import { Page } from '../../adapters/page';


@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {

	year : number = (new Date()).getFullYear();

	constructor(private page: Page) {

		this.page.actionBarHidden = true;
	}

	ngOnInit() {
		
	}

}
